import React, {useEffect, useState} from 'react';
import opengraphAPI from '../../../../shared/apis/opengraph-api-web';
import styles from './SitePreviewCard.module.css';
import XIcon from '../svgs/XIcon';
import debounce from 'lodash.debounce';

import {Card, CardMedia, CardContent, IconButton} from '@material-ui/core';
import {
  getDomain,
  validURL,
  setOpenGraphData,
  cleanLinkID,
} from '../../../../shared/utils/Helpers';
import {handleLinkClick} from '../../../../shared/utils/HandleLinkClick';

const DEBOUNCE_MS = 1000;
const SitePreviewCard = (props) => {
  const [data, setData] = useState(null);
  const {link, onClose, cancelable, storePreviewData, graphData} = props;
  // openGraph always adds a trailing / after url
  // open graph sometimes removes analytic data (trailing ?), making analytic links never match their format
  const newLink =
    cleanLinkID(graphData?.url) !== cleanLinkID(link) &&
    graphData?.url?.slice(0, -1) !== link;
  useEffect(() => {
    if ((!graphData || newLink) && validURL(link)) {
      const debouncedOpenGraph = debounce(() => {
        opengraphAPI
          .get(link)
          .then((data) => {
            if (
              !data?.openGraph?.error ||
              !data?.hybridGraph?.error ||
              !data?.htmlInferred?.error
            ) {
              const openGraphData = setOpenGraphData(
                data?.openGraph,
                data?.hybridGraph,
                data?.htmlInferred,
                data?.url,
              );
              setData(openGraphData);
              if (storePreviewData) storePreviewData(openGraphData);
            }
          })
          .catch((err) => {
            console.warn('Error fetching site data', err);
          });
      }, DEBOUNCE_MS);
      debouncedOpenGraph();
      return () => debouncedOpenGraph.cancel();
    } else {
      setData(graphData);
    }
  }, [link]);

  const openLink = (evt, url) => {
    evt.stopPropagation();
    evt.preventDefault();
    handleLinkClick(url);
  };

  return (
    <>
      {data ? (
        <Card
          className={styles.cardContainer}
          onClick={(e) => openLink(e, link)}>
          {/* image_url used for backend stored image url */}
          <CardMedia
            component="img"
            className={styles.cardCover}
            src={data.image || data.image_url}
            alt="Page preview"
          />
          <CardContent className={styles.cardContent}>
            <div>
              <div className={styles.siteTitle}>{data.title}</div>
              {data.description && (
                <p className={styles.siteDescription}>{data.description}</p>
              )}
            </div>
            <div className={styles.siteLink}>{getDomain(data.url)}</div>
          </CardContent>
          {cancelable ? (
            <div>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  onClose();
                }}
                className={styles.cancelButton}
                color="inherit">
                <XIcon tintColor="var(--magenta)" />
              </IconButton>
            </div>
          ) : null}
        </Card>
      ) : null}
    </>
  );
};

export default SitePreviewCard;
